module.exports = __webpack_public_path__ + "img/ico-up-arrow.a116dce0.svg";